export const isEmpty = entity => !entity || Object.keys(entity).length === 0